module.exports = __webpack_public_path__ + "img/content_bg.b7ef0962.png";